import { get } from 'axios'

export default {
    actions: {
        async retrieve(ctx) {
            if (ctx.state.objectTypes.length) return ctx.commit('updateObjectTypes', ctx.state.objectTypes)
            console.time('glb-object-types')
            const request = await get('/glbObjectType')
            const label = `[vuex] [global] Get object types [${request.data.Data.length}]`;
            console.groupCollapsed(label);
            console.info(request.data.Data);
            console.timeEnd('glb-object-types')
            console.groupEnd(label);

            return ctx.commit('updateObjectTypes', request.data.Data)
        }
    },
    mutations: {
        updateObjectTypes(state, objectTypes) {
            state.objectTypes = [...objectTypes]
        },
    },
    state: {
        objectTypes: [],
    },
    getters: {
        getObjectTypes(state) {
            return state.objectTypes
        },
        resolveObjectType(state) {
            return ({ ObjectTypeID, object_type_id }) => {
                return state.objectTypes.find(f => f.ObjectTypeID == (ObjectTypeID || object_type_id))
            }
        },
        typesByGroups(state) {
            return (ObjectGroupID) => {
                if (typeof ObjectGroupID == 'number')
                    return state.objectTypes.filter(t => [null, undefined].includes(ObjectGroupID) || t.ObjectGroupID == ObjectGroupID)
                else if (Array.isArray(ObjectGroupID))
                    return (ObjectGroupID.length == 0) ? state.objectTypes : state.objectTypes.filter(t => ObjectGroupID.includes(t.ObjectGroupID))
            }
        }
    },
}